export default "<img src=\"assets/logo_cropped.png\" uiSref=\"home\" />"